import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SharedLayout from './pages/SharedLayout';
import Home from './pages/Home/home';
import Categories from './pages/Categories/categories';
import Error from './pages/Error/error';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<SharedLayout />}>
        <Route path="/" index element={<Home />} />
        <Route path="categories" element={<Categories />} />
        <Route path="*" element={<Error />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default App;
